// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInvitedStatusCard_root__wDJvO","text":"PlasmicInvitedStatusCard_text__zAtMw"};